// Staff role ladder, mirrored from the cloud API's middleware/authorize.js.
// The server enforces every rule again - these helpers only shape what the
// UI offers so people don't see pages and buttons that would 403 on them.
export const ROLE_RANK = { employee: 1, admin: 2, developer: 3 };

export const ROLE_LABELS = {
  employee: 'Employee',
  admin: 'Admin',
  developer: 'Developer',
  // Historical log entries can still carry the pre-rename role name
  superadmin: 'Developer',
};

// True when role holds minRole or anything above it on the ladder
export const hasRole = (role, minRole) => (ROLE_RANK[role] || 0) >= ROLE_RANK[minRole];

// Where each role lands after login: developers get the system overview,
// everyone else starts at the device list
export const landingPage = (role) => (hasRole(role, 'developer') ? 'overview' : 'devices');

// One colour per staff role, shared by the badge in the employee table and the
// tally cards above it so the two cannot drift apart. Purple sits at the top of
// the ladder, blue in the middle, indigo for the base role.
export const ROLE_COLORS = {
  developer: { badge: 'bg-purple-100 text-purple-800', value: 'text-purple-600', icon: 'text-purple-500' },
  admin: { badge: 'bg-blue-100 text-blue-800', value: 'text-blue-600', icon: 'text-blue-500' },
  employee: { badge: 'bg-indigo-100 text-indigo-800', value: 'text-indigo-600', icon: 'text-indigo-500' },
};

export const roleColors = (role) =>
  ROLE_COLORS[role === 'superadmin' ? 'developer' : role] || ROLE_COLORS.employee;
